import React from "react"
import Cabecalho from "../Cabecalho"
import { Loading } from "../RegistradorDePedidos"
import { AlertasPainelForm } from "./components/AlertasPainelForm"

export function Index() {
    return (
        <>
            <Cabecalho pagina="Alertas do painel" />
            <Loading />
            <AlertasPainelForm />
        </>
    )
}
